/* globals jQuery */
import './jquery.fitvids.js'
import './jquery.flexslider.js';
import './jquery.accordion.js'
import './responsive-nav.jquery.js'
import './magnific-popup.js'

(function($) {

	// Make nav menu nice & responsive
	$('nav.main-nav').responsiveNav({
		navType: 'offCanvas' //default option for dropdown type use 'dropdown'
	});

	// Responsive Videos
	$('.rtecontent').fitVids();

	// Accordions
	$('dl.accordion').accordion();


	// Magnific Modal Popups
	$('.js-auction-item-pop').magnificPopup({
	  	type: 'inline',
		midClick: true,
		mainClass: 'mfp-fade',// fades modal in
      	removalDelay: 500,//waits to remove for animation
		closeMarkup: '<button title="%title%" type="button" class="mfp-close">Close</button>',
		callbacks: {
			elementParse: function(item) {
				var auctionItemId = $(item.el).data('id');
				//console.log(auctionItemId);
				var data = {
					action : 'get_auction_item',
					auctionItemId : auctionItemId
				};

				$.post(wp_ajax.url, data, function(response) {

					$('#auction-item-popup').append(response);
                    $('#auction-item-popup .spinner').hide();
                    
                    // gallery flexslider
                    $('.flexslider').flexslider({
                        pauseOnHover: true,
                        slideshow: $('#gallery-auto-rotate').val(),
                        slideshowSpeed: $('#gallery-speed').val() * 1000,
                        controlNav: false,
                        prevText: "&laquo;",
                        nextText: "&raquo;"
                    });

                });

			},
			close: function(){
				$('#auction-item-popup .spinner').show();
				$('#auction-item-popup .auction-items-details-content').remove();
			}
		}
    });

	// gallery flexslider
	$('.flexslider').flexslider({
		pauseOnHover: true,
		slideshow: $('#gallery-auto-rotate').val(),
		slideshowSpeed: $('#gallery-speed').val() * 1000,
		controlNav: false,
		prevText: "&laquo;",
		nextText: "&raquo;"
	});


})(jQuery);
